<template>
  <v-card outlined class="mb-3">
    <v-card-text>
      <div class="d-flex justify-space-between align-center mb-2">
        <div>
          <strong>{{ change.question }}</strong>
          <v-chip v-if="change.is_new" x-small outlined color="primary" class="ml-2">Novo bloco</v-chip>
        </div>
        <v-chip v-if="change.status === 'accepted'" x-small color="success" outlined>Aplicada</v-chip>
        <v-chip v-else-if="change.status === 'rejected'" x-small outlined>Recusada</v-chip>
      </div>

      <div v-if="change.stale && change.status === 'pending'" class="stale-warning mb-2">
        <app-icon size="16" class="mr-1">warning</app-icon>
        O texto atual mudou desde esta sugestão.
      </div>

      <div v-else-if="change.stale && change.status === 'accepted'" class="stale-warning mb-2">
        <app-icon size="16" class="mr-1">warning</app-icon>
        O documento foi alterado por uma edição mais recente — não é possível desfazer esta.
      </div>

      <div v-if="!change.is_new" class="mb-2">
        <div class="text-caption text-medium-emphasis mb-1">Atual</div>
        <div v-if="change.html" class="answer-block answer-before" v-html="sanitizedBefore"></div>
        <div v-else class="answer-block answer-before">{{ change.before || '(vazio)' }}</div>
      </div>

      <div class="mb-2">
        <div class="text-caption text-medium-emphasis mb-1">Sugerido</div>
        <div v-if="change.html" class="answer-block answer-after" v-html="sanitizedAfter"></div>
        <div v-else class="answer-block answer-after">{{ change.after }}</div>
      </div>

      <div v-if="change.reason" class="text-caption text-medium-emphasis mb-3">{{ change.reason }}</div>

      <div v-if="change.status === 'pending'">
        <v-btn v-if="change.stale && !armed" small outlined @click="armed = true">
          O texto mudou — aplicar mesmo assim?
        </v-btn>
        <template v-else>
          <v-btn class="mr-2" small outlined @click="$emit('decide', 'rejected')">
            <app-icon class="mr-1" size="16">thumb_down</app-icon>
            Recusar
          </v-btn>
          <v-btn small color="primary" outlined @click="$emit('decide', 'accepted')">
            <app-icon class="mr-1" size="16">thumb_up</app-icon>
            Aceitar
          </v-btn>
        </template>
      </div>
      <div v-else-if="!(change.status === 'accepted' && change.stale)">
        <v-btn small text @click="$emit('decide', 'pending')">Desfazer</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
// Proposed content is model output, never trusted as-is: sanitize before
// v-html the same way AgentAssistantMessage disables raw HTML in markdown-it.
import DOMPurify from 'dompurify'

export default {
  name: 'AgentDiffCard',
  props: {
    change: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      armed: false,
    }
  },
  computed: {
    sanitizedBefore() {
      return DOMPurify.sanitize(this.change.before || '(vazio)')
    },
    sanitizedAfter() {
      return DOMPurify.sanitize(this.change.after || '')
    },
  },
  watch: {
    'change.id'() {
      this.armed = false
    },
  },
}
</script>

<style scoped>
.answer-block {
  white-space: pre-wrap;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
}

.answer-before {
  background: #f5f5f5;
  color: rgba(0, 0, 0, 0.6);
}

.answer-after {
  background: #ece9fb;
}

.stale-warning {
  color: #b45309;
  font-size: 12px;
  display: flex;
  align-items: center;
}
</style>
